export { default } from './TrianglesContainer'
